import type { ComponentPropsWithRef } from 'react'
import cn from 'classnames'
import { Items } from '@/scopes/common/components/Drawer/Items'
import styles from './Drawer.module.css'

interface DrawerProps extends ComponentPropsWithRef<'div'> {
  isDisabled?: boolean
}

function InnerDrawer({ ref, isDisabled, className, ...props }: DrawerProps) {
  return (
    <div
      ref={ref}
      className={cn(styles.drawer, isDisabled && styles.disabled, className)}
      {...props}
    />
  )
}

InnerDrawer.displayName = 'Drawer'

export const Drawer = Object.assign(InnerDrawer, { Items })
